// extracted by mini-css-extract-plugin
export default {"mobileRecorderTable":"MobileRecorderEntries_mobileRecorderTable__9rhr9"};